var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.detail)?_c('reward-item',{attrs:{"title":"恭喜您获得数字藏品","description":_vm.detail.productName,"img":_vm.detail.smallImage},on:{"maskClose":_vm.handleCloseTip,"close":_vm.handleCloseTip,"tapBtn":_vm.handleCloseTip}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }